// Strokes ↔ JSON-safe form. Pen/eraser strokes are already JSON-clean;
// fills carry a Uint8Array mask that we PNG-encode (matches the pattern
// in saveReference.js). PNG is ~50-100× denser than raw base64 since the
// 0/255 mask compresses trivially. Decoding is async because PNG decode
// requires <img>.

export const STROKES_SCHEMA_VERSION = 1;

function maskToPngDataUrl(mask, w, h) {
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  const imgData = ctx.createImageData(w, h);
  const data = imgData.data;
  for (let i = 0; i < mask.length; i++) {
    if (mask[i]) {
      const di = i * 4;
      data[di] = 255;
      data[di + 1] = 255;
      data[di + 2] = 255;
      data[di + 3] = 255;
    }
  }
  ctx.putImageData(imgData, 0, 0);
  return canvas.toDataURL("image/png");
}

function pngDataUrlToMask(dataUrl, w, h) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const { data } = ctx.getImageData(0, 0, w, h);
      const mask = new Uint8Array(w * h);
      for (let i = 0; i < mask.length; i++) {
        mask[i] = data[i * 4 + 3] > 0 ? 1 : 0;
      }
      resolve(mask);
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
}

export function serializeStrokes(strokes) {
  return strokes.map((s) => {
    if (s.tool === "fill") {
      const { bbox, mask, ...rest } = s;
      return {
        ...rest,
        bbox,
        maskPng: maskToPngDataUrl(mask, bbox.w, bbox.h),
      };
    }
    return s;
  });
}

export async function deserializeStrokes(serialized) {
  return Promise.all(
    serialized.map(async (s) => {
      if (s.tool === "fill") {
        const { maskPng, bbox, ...rest } = s;
        const mask = await pngDataUrlToMask(maskPng, bbox.w, bbox.h);
        return { ...rest, bbox, mask };
      }
      return s;
    }),
  );
}
